import { setFoodChoiceReq } from '../actions/cacheActions'
import { setViewFoodDetails } from '../actions/orderActions'
import { FOOD_KIND } from '../constants'

export const getActionViewFood = food => {
    return !!food.subs
        ? setFoodChoiceReq(food.subs.map(f => ({ ...f, parent: food })))
        : setViewFoodDetails(
              food?.parent
                  ? {
                        ...food.parent,
                        foodIndexSelected: food.foodIndexSelected,
                    }
                  : food
          )
}
